module.exports = __webpack_public_path__ + "static/media/summary.cc28c68a.md";